"use strict";

var _defineProperty = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/slicedToArray");

var _toArray = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/toArray");

var _exports$defaultConve;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var _ = require("lodash");

require("reflect-metadata");

exports.defaultConverters = (_exports$defaultConve = {}, _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.CUSTOM_VALIDATION, function (meta, options) {
  if (_.isFunction(meta.target)) {
    var type = getPropType(meta.target.prototype, meta.propertyName);
    return targetToSchema(type, options);
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.NESTED_VALIDATION, function (meta, options) {
  if (_.isFunction(meta.target)) {
    var typeMeta = options.classTransformerMetadataStorage ? options.classTransformerMetadataStorage.findTypeMetadata(meta.target, meta.propertyName) : null;
    var childType = typeMeta ? typeMeta.typeFunction() : getPropType(meta.target.prototype, meta.propertyName);
    return targetToSchema(childType, options);
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.CONDITIONAL_VALIDATION, {}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_DEFINED, {}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.EQUALS, function (meta) {
  var schema = constraintToSchema(meta.constraints[0]);

  if (schema) {
    return Object.assign({}, schema, {
      enum: [meta.constraints[0]]
    });
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.NOT_EQUALS, function (meta) {
  var schema = constraintToSchema(meta.constraints[0]);

  if (schema) {
    return {
      not: Object.assign({}, schema, {
        enum: [meta.constraints[0]]
      })
    };
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_EMPTY, {
  anyOf: [{
    type: 'string',
    enum: ['']
  }, {
    not: {
      anyOf: [{
        type: 'string'
      }, {
        type: 'number'
      }, {
        type: 'boolean'
      }, {
        type: 'integer'
      }, {
        type: 'array'
      }, {
        type: 'object'
      }]
    },
    nullable: true
  }]
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_NOT_EMPTY, {
  minLength: 1,
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_IN, function (meta) {
  var _meta$constraints$0$m = meta.constraints[0].map(constraintToSchema),
      _meta$constraints$0$m2 = _toArray(_meta$constraints$0$m),
      head = _meta$constraints$0$m2[0],
      rest = _meta$constraints$0$m2.slice(1);

  if (head && _.every(rest, {
    type: head.type
  })) {
    return Object.assign({}, head, {
      enum: meta.constraints[0]
    });
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_NOT_IN, function (meta) {
  var _meta$constraints$0$m3 = meta.constraints[0].map(constraintToSchema),
      _meta$constraints$0$m4 = _toArray(_meta$constraints$0$m3),
      head = _meta$constraints$0$m4[0],
      rest = _meta$constraints$0$m4.slice(1);

  if (head && _.every(rest, {
    type: head.type
  })) {
    return {
      not: Object.assign({}, head, {
        enum: meta.constraints[0]
      })
    };
  }
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_BOOLEAN, {
  type: 'boolean'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_DATE, {
  oneOf: [{
    format: 'date',
    type: 'string'
  }, {
    format: 'date-time',
    type: 'string'
  }]
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_NUMBER, {
  type: 'number'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_STRING, {
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_DATE_STRING, {
  pattern: 'd{4}-[01]d-[0-3]dT[0-2]d:[0-5]d:[0-5]d.d+Z?',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ARRAY, {
  items: {},
  type: 'array'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_INT, {
  type: 'integer'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ENUM, function (meta) {
  return {
    enum: Object.keys(meta.constraints[0]),
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_DIVISIBLE_BY, function (meta) {
  return {
    multipleOf: meta.constraints[0],
    type: 'number'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_POSITIVE, {
  exclusiveMinimum: true,
  minimum: 0,
  type: 'number'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_NEGATIVE, {
  exclusiveMaximum: true,
  maximum: 0,
  type: 'number'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MIN, function (meta) {
  return {
    minimum: meta.constraints[0],
    type: 'number'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MAX, function (meta) {
  return {
    maximum: meta.constraints[0],
    type: 'number'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MIN_DATE, function (meta) {
  return {
    description: "After ".concat(meta.constraints[0].toJSON()),
    oneOf: [{
      format: 'date',
      type: 'string'
    }, {
      format: 'date-time',
      type: 'string'
    }]
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MAX_DATE, function (meta) {
  return {
    description: "Before ".concat(meta.constraints[0].toJSON()),
    oneOf: [{
      format: 'date',
      type: 'string'
    }, {
      format: 'date-time',
      type: 'string'
    }]
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_BOOLEAN_STRING, {
  enum: ['true', 'false'],
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_NUMBER_STRING, {
  pattern: '^[-+]?[0-9]+$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.CONTAINS, function (meta) {
  return {
    pattern: meta.constraints[0],
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.NOT_CONTAINS, function (meta) {
  return {
    not: {
      pattern: meta.constraints[0]
    },
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ALPHA, {
  pattern: '^[a-zA-Z]+$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ALPHANUMERIC, {
  pattern: '^[0-9a-zA-Z]+$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ASCII, {
  pattern: '^[\\x00-\\x7F]+$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_BASE64, {
  format: 'base64',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_BYTE_LENGTH, {
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_CREDIT_CARD, {
  format: 'credit-card',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_CURRENCY, {
  format: 'currency',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_EMAIL, {
  format: 'email',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_FQDN, {
  format: 'hostname',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_FULL_WIDTH, {
  pattern: "[^\\u0020-\\u007E\\uFF61-\\uFF9F\\uFFA0-\\uFFDC\\uFFE8-\\uFFEE0-9a-zA-Z]",
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_HALF_WIDTH, {
  pattern: "[\\u0020-\\u007E\\uFF61-\\uFF9F\\uFFA0-\\uFFDC\\uFFE8-\\uFFEE0-9a-zA-Z]",
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_VARIABLE_WIDTH, {
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_HEX_COLOR, {
  pattern: '^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_HEXADECIMAL, {
  pattern: '^[0-9a-fA-F]+$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_IP, function (meta) {
  return {
    format: 'ipv' + (meta.constraints[0] === '6' ? 6 : 4),
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ISBN, {
  format: 'isbn',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ISIN, {
  format: 'isin',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_ISO8601, {
  oneOf: [{
    format: 'date',
    type: 'string'
  }, {
    format: 'date-time',
    type: 'string'
  }]
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_JSON, {
  format: 'json',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_LOWERCASE, {
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_MOBILE_PHONE, {
  format: 'mobile-phone',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_MONGO_ID, {
  pattern: '^[0-9a-fA-F]{24}$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_MULTIBYTE, {
  pattern: '[^\\x00-\\x7F]',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_SURROGATE_PAIR, {
  pattern: "[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]",
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_URL, {
  format: 'url',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_UUID, {
  format: 'uuid',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.LENGTH, function (meta) {
  var _meta$constraints = _slicedToArray(meta.constraints, 2),
      minLength = _meta$constraints[0],
      maxLength = _meta$constraints[1];

  if (maxLength || maxLength === 0) {
    return {
      minLength: minLength,
      maxLength: maxLength,
      type: 'string'
    };
  }

  return {
    minLength: minLength,
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_UPPERCASE, {
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MIN_LENGTH, function (meta) {
  return {
    minLength: meta.constraints[0],
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MAX_LENGTH, function (meta) {
  return {
    maxLength: meta.constraints[0],
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.MATCHES, function (meta) {
  return {
    pattern: meta.constraints[0].source,
    type: 'string'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.IS_MILITARY_TIME, {
  pattern: '^([01]\\d|2[0-3]):?([0-5]\\d)$',
  type: 'string'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_CONTAINS, function (meta) {
  var schemas = meta.constraints[0].map(constraintToSchema);

  if (schemas.length > 0 && _.every(schemas, 'type')) {
    return {
      not: {
        anyOf: _.map(schemas, function (d, i) {
          return {
            items: {
              not: Object.assign({}, d, {
                enum: [meta.constraints[0][i]]
              })
            }
          };
        })
      },
      type: 'array'
    };
  }

  return {
    items: {},
    type: 'array'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_NOT_CONTAINS, function (meta) {
  var schemas = meta.constraints[0].map(constraintToSchema);

  if (schemas.length > 0 && _.every(schemas, 'type')) {
    return {
      items: {
        not: {
          anyOf: _.map(schemas, function (d, i) {
            return Object.assign({}, d, {
              enum: [meta.constraints[0][i]]
            });
          })
        }
      },
      type: 'array'
    };
  }

  return {
    items: {},
    type: 'array'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_NOT_EMPTY, {
  items: {},
  minItems: 1,
  type: 'array'
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_MIN_SIZE, function (meta) {
  return {
    items: {},
    minItems: meta.constraints[0],
    type: 'array'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_MAX_SIZE, function (meta) {
  return {
    items: {},
    maxItems: meta.constraints[0],
    type: 'array'
  };
}), _defineProperty(_exports$defaultConve, class_validator_1.ValidationTypes.ARRAY_UNIQUE, {
  items: {},
  type: 'array',
  uniqueItems: true
}), _exports$defaultConve);

function getPropType(target, property) {
  return Reflect.getMetadata('design:type', target, property);
}

function constraintToSchema(primitive) {
  var primitives = ['string', 'number', 'boolean'];
  var type = typeof primitive;

  if (_.includes(primitives, type)) {
    return {
      type: type
    };
  }
}

function targetToSchema(type, options) {
  if (_.isFunction(type)) {
    if (_.isString(type.prototype) || _.isSymbol(type.prototype)) {
      return {
        type: 'string'
      };
    } else if (_.isNumber(type.prototype)) {
      return {
        type: 'number'
      };
    } else if (_.isBoolean(type.prototype)) {
      return {
        type: 'boolean'
      };
    }

    return {
      $ref: options.refPointerPrefix + type.name
    };
  }
}